<template>
  <el-row>
    <el-col
      class="content"
      :xl="{ span: 18 }"
      :lg="{ span: 18 }"
      :md="{ span: 18 }"
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
    >
      <div class="mydoc">
        <div class="header" style="font-weight: 900">学术信息</div>
        <div class="mybody">
          <ul>
            <li
              v-for="(item, index) in academicInformation"
              :key="index"
              :data-obj="JSON.stringify(item)"
              :id="index + 1"
            >
              <el-row
                style="color: #006a71; cursor: pointer"
                @click.native="academicInformationDetail(item)"
              >
                <el-col :span="1"><span class="dot"></span></el-col>
                <el-col :span="13" class="title"
                  ><span class="new_title" v-text="item.reportTitle"></span
                ></el-col>
                <el-col :span="2" :offset="1"
                  ><span class="new_title" v-text="item.reporter"></span
                ></el-col>
                <el-col :span="2" :offset="1"
                  ><span class="exceed new_title" v-text="item.reportDate"></span
                ></el-col>
                <el-col :span="24"><br /></el-col>
              </el-row>
            </li>
            <br />
          </ul>
          <el-dialog :visible.sync="academicDialogVisible" fullscreen>
            <el-image style="width: 80%; height: 100%" :src="poster"></el-image>
          </el-dialog>
        </div>
      </div>
    </el-col>
    <el-col
      :xl="{ span: 6 }"
      :lg="{ span: 6 }"
      :md="{ span: 6 }"
      :xs="{ span: 24 }"
      :sm="{ span: 24 }"
    >
      <!--右边登录部分-->

      <loginComponent></loginComponent>
    </el-col>
  </el-row>
</template>

<script>
import loginComponent from '@/components/loginComponent'

export default {
  name: 'notic',
  components: {
    loginComponent
  },
  data () {
    return {
      academicInformation: [
        {
          reportTitle: '来自江淮方言的普通话词',
          reporter: '岩田礼',
          reportDate: '3月8日 19:00',
          poster: '../../static/materials/岩田礼教授3月8.jpg',
          category: 'information'
        },
        {
          reportTitle: '语言与“生老病死”',
          reporter: '王士元',
          reportDate: '3月13日 19:00',
          poster: '../../static/materials/王士元教授3月13.jpg',
          category: 'information'
        },
        {
          reportTitle: 'ChatGPT冲击下语言学对NLP价值的再思考',
          reporter: '白硕',
          reportDate: '3月15日 19:00',
          poster: '../../static/materials/白硕教授3月15.jpg',
          category: 'information'
        },
        {
          reportTitle: '汉语声调系统的重音问题',
          reporter: '许希明',
          reportDate: '3月22日  19:00',
          poster: '../../static/materials/许希明教授3月22.jpg',
          category: 'information'
        },
        {
          reportTitle: '从语言类型学看南岛语言的语法特点',
          reporter: '潘家荣',
          reportDate: '3月27日  19:00',
          poster: '../../static/materials/潘家荣教授3月27.jpg',
          category: 'information'
        },
        {
          reportTitle: '语言景观中的变异与规范言语社区理论的新发展',
          reporter: '徐大明',
          reportDate: '4月6日  19:00',
          poster: '../../static/materials/徐大明教授4月6.jpg',
          category: 'information'
        },
        {
          reportTitle: '我与汉英语对比研究',
          reporter: '潘文国',
          reportDate: '4月12日  15:00',
          poster: '../../static/materials/潘文国教授4月12.jpg',
          category: 'information'
        },
        {
          reportTitle: 'Greenberg(1966)以来的语序研究',
          reporter: '陆丙甫',
          reportDate: '4月21日  19:00',
          poster: '../../static/materials/陆丙甫教授4月21.jpg',
          category: 'information'
        },
        {
          reportTitle: '语言之谜---来自人工智能的挑战',
          reporter: '石锋',
          reportDate: '4月26日  19:00',
          poster: '../../static/materials/石锋教授4月26.jpg',
          category: 'information'
        },
        {
          reportTitle: '为什么我们并非面向过去：时空认知与表达的模组分析',
          reporter: '张敏',
          reportDate: '5月10日  19:00',
          poster: '../../static/materials/张敏教授5月10.jpg',
          category: 'information'
        },
        {
          reportTitle: 'Digital Language Learning (DLL):Technology, Data ,and the Brain',
          reporter: 'Prof. Ping Li',
          reportDate: '5月17日  19:00',
          poster: '../../static/materials/5.17 ProfPingLi.jpg',
          category: 'information'
        },
        {
          reportTitle: '语言学田野调查的故事、假设与实践',
          reporter: '汪锋',
          reportDate: '5月24日  19:00',
          poster: '../../static/materials/汪锋教授5月24.jpg',
          category: 'information'
        }
        // {
        //   reportTitle: '赵元任语言实验之星评奖结果',
        //   reporter: '评奖委员会',
        //   reportDate: '2022年10月28日',
        //   poster: '../../static/materials/zyrj.png',
        //   category: 'information'
        // },
        // {
        //   reportTitle: '小议语义的形式',
        //   reporter: '陆俭明',
        //   reportDate: '9月5日 19:00',
        //   poster: '../../static/materials/ljm.png',
        //   category: 'information'
        // },
        // {
        //   reportTitle: '汉语语法认知视角教学及其方法与途径',
        //   reporter: '卢福波',
        //   reportDate: '9月7日 19:00',
        //   poster: '../../static/materials/lfb.png',
        //   category: 'information'
        // },
        // {
        //   reportTitle: '汉语方言语法文白叠置现象的再探讨',
        //   reporter: '汪化云',
        //   reportDate: '9月14日 19:00',
        //   poster: '../../static/materials/why.jpg',
        //   category: 'information'
        // },
        // {
        //   reportTitle: '再识柔性——————语法探索的心路',
        //   reporter: '史有为',
        //   reportDate: '9月19日 19:00',
        //   poster: '../../static/materials/syw.jpg',
        //   category: 'information'
        // },
        // {
        //   reportTitle: '人脑语言中枢定位研究',
        //   reporter: '谭力海',
        //   reportDate: '9月21日 19:00',
        //   poster: '../../static/materials/tlh.png',
        //   category: 'information'
        // },
        // {
        //   reportTitle: '从大脑视角看语言与认知',
        //   reporter: '李佳颖',
        //   reportDate: '9月21日 19:00',
        //   poster: '../../static/materials/ljy.jpg',
        //   category: 'information'
        // },
        // {
        //   reportTitle: '作为检验研究成效一项重要指标的独立论证',
        //   reporter: '徐杰',
        //   reportDate: '9月28日 19:00',
        //   poster: '../../static/materials/xj.png',
        //   category: 'information'
        // },
        // {
        //   reportTitle: '焦点感知',
        //   reporter: '王蓓',
        //   reportDate: '10月24日 19:00',
        //   poster: '../../static/materials/wb.jpg',
        //   category: 'information'
        // },
        // {
        //   reportTitle: '复杂词内部层级的制图研究',
        //   reporter: '司富珍',
        //   reportDate: '10月26日 19:00',
        //   poster: '../../static/materials/sfz.jpg',
        //   category: 'information'
        // }
        // {
        //   reportTitle: "再谈语音研究中的三个关系",
        //   reporter: "石锋",
        //   reportDate: "4月20日 （周三） 19:00",
        //   poster: "../../static/materials/石锋.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "人工智能与语言计算",
        //   reporter: "孙茂松",
        //   reportDate: "3月2日 （周三） 19:00",
        //   poster: "../../static/materials/孙茂松.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "小句、句子和语言认知",
        //   reporter: "宋柔",
        //   reportDate: "3月7日 （周一） 19:00",
        //   poster: "../../static/materials/宋柔.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle:
        //     "Representations of linguistic communicative goals in premotor cortex",
        //   reporter: "周晓林",
        //   reportDate: "3月14日 （周一） 20:00",
        //   poster: "../../static/materials/周晓林.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle:
        //     "汉语几项历史语音变化的结构因素与生理基础：以合口三等音节为例",
        //   reporter: "郑伟",
        //   reportDate: "3月16日 （周三） 19:00",
        //   poster: "../../static/materials/郑伟.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle:
        //     "基于认知并面向计算的语言学研究进路——走向人文精神与科技理性的有机结合",
        //   reporter: "袁毓林",
        //   reportDate: "3月2日 （周三） 19:00",
        //   poster: "../../static/materials/袁毓林.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "语音声学距离能做什么？——对一些语音问题的分析探索",
        //   reporter: "冉启斌",
        //   reportDate: "3月2日 （周三） 19:00",
        //   poster: "../../static/materials/冉启斌.jpg",
        //   category: "information",
        // },

        // {
        //   reportTitle: "连续话语中基本语言单元的提取",
        //   reporter: "祖漪清",
        //   reportDate: "3月9日 （周三） 19:00",
        //   poster: "../../static/materials/祖漪清.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "关联语法及其自动解析",
        //   reporter: "白硕",
        //   reportDate: "3月21日 （周一） 19:00",
        //   poster: "../../static/materials/白硕.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "语序、论元配置的混合性与汉语语法类型",
        //   reporter: "金立鑫",
        //   reportDate: "3月23日 （周三） 19:00",
        //   poster: "../../static/materials/金立鑫.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "音位结构功能负担量的计算方法",
        //   reporter: "李永宏",
        //   reportDate: "3月28日 （周一） 19:00",
        //   poster: "../../static/materials/李永宏.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "关系语素与文明探源",
        //   reporter: "潘悟云",
        //   reportDate: "4月11日 （周一） 19:00",
        //   poster: "../../static/materials/潘悟云.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "汉语阅读理解的眼动研究",
        //   reporter: "白学军",
        //   reportDate: "4月13日 （周三） 19:00",
        //   poster: "../../static/materials/白学军.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "谈谈语音能力在语法研究中的重要性——以藏缅语为例",
        //   reporter: "戴庆厦",
        //   reportDate: "4月18日 （周一） 19:00",
        //   poster: "../../static/materials/戴庆厦.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "可延展性：音节及其音核的可判定属性",
        //   reporter: "陈保亚",
        //   reportDate: "4月25日 （周一） 19:00",
        //   poster: "../../static/materials/陈保亚.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "海外话语研究的一些进展",
        //   reporter: "郭熙",
        //   reportDate: "4月27日 （周三） 19:00",
        //   poster: "../../static/materials/郭熙.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "可视化手段在汉语语言学研究与教学中的应用漫谈",
        //   reporter: "陶红印",
        //   reportDate: "5月8日 （周日） 10:00",
        //   poster: "../../static/materials/陶红印.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "基于字音声学数据的方言声调系统分析",
        //   reporter: "熊子瑜",
        //   reportDate: "5月11日 （周三） 19:00",
        //   poster: "../../static/materials/熊子瑜.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "论索绪尔的语言学第二原理——语言符号的线条性",
        //   reporter: "远藤光晓",
        //   reportDate: "5月16日 （周一） 19:00",
        //   poster: "../../static/materials/远藤光晓.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle:
        //     "感音神经性聋听觉及语言相关脑区功能探索与手语感知的脑机制",
        //   reporter: "顾文涛",
        //   reportDate: "5月24日 （周二） 20:00",
        //   poster: "../../static/materials/顾文涛.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "Non-Structuralist Linguistics (非结构主义语言学)",
        //   reporter: "罗仁地",
        //   reportDate: "5月25日 （周三） 19:00",
        //   poster: "../../static/materials/罗仁地.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "试解普通话语调原理（修订版）",
        //   reporter: "石锋",
        //   reportDate: "5月30日 （周一） 19:00",
        //   poster: "../../static/materials/石锋.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "汉语“连”字句的韵律焦点分析",
        //   reporter: "温宝莹",
        //   reportDate: "6月1日 （周三） 19:00",
        //   poster: "../../static/materials/温宝莹.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "老龄化对汉语耳语语音感知的影响",
        //   reporter: "续敏",
        //   reportDate: "6月6日 （周一） 19:00",
        //   poster: "../../static/materials/续敏.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "基于口语调查和实验分析的对话研究",
        //   reporter: "方梅",
        //   reportDate: "6月8日 （周三） 19:00",
        //   poster: "../../static/materials/方梅.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle:
        //     "感音神经性聋听觉及语言相关The speech-music relationship: What we can learn from congenital amusia (tone deafness)",
        //   reporter: "张偲偲",
        //   reportDate: "6月13日 （周一） 14:00",
        //   poster: "../../static/materials/张偲偲.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle: "Praat汉化修改版的几个基本操作",
        //   reporter: "贝先明",
        //   reportDate: "6月15日 （周三） 19:00",
        //   poster: "../../static/materials/贝先明.jpg",
        //   category: "information",
        // },
        // {
        //   reportTitle:
        //     "感音神经性聋听觉及语言相关脑区功能探索与手语感知的脑机制",
        //   reporter: "李强",
        //   reportDate: "5月18日 （周三） 19:00",
        //   poster: "../../static/materials/李强.jpg",
        //   category: "information",
        // },
      ],
      academicDialogVisible: false
    }
  },
  methods: {
    academicInformationDetail (item) {
      this.academicDialogVisible = true
      this.poster = item.poster
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row {
  //   background-color: white;
  margin: auto;
}
.new_title {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: clip; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行*/
  display: block;
}

.introduction_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.introduction {
  border: 1px solid #b3c0d1;
  height: 920px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}

.about {
  min-height: calc(100vh - 8rem);
}
.showappbox {
  display: flex;
  .left {
    text-align: left;
  }
}

.content {
  margin-top: 12px;
  .mylink {
    height: 18rem;
    border-radius: 4px;
    background: rgba($color: #ffffff, $alpha: 0.5);
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    .mybody {
      //   padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      .body-item {
        cursor: pointer;
      }
      .num {
        font-size: 55px;
        font-weight: bold;
      }
    }
  }
  .mydoc {
    border-radius: 4px;
    min-height: 20rem;
    box-shadow: 2px 3px 10px rgb(51, 72, 94);
    text-align: left;
    .mybody {
      //   background: linear-gradient(45deg, #34495e, #41b883);
      height: 940px;
      padding: 10px;
      background-color: white;
      overflow: auto;
    }
    p {
      color: black;
      text-indent: 30px;
      line-height: 24px;
      padding: 10px;
    }
  }
}
.header {
  padding: 10px;
  text-align: left;
  background-color: gainsboro;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-bottom: 1px solid gainsboro;
}

.main_pre {
  width: auto;
  margin: 10px 5px 10px 5px; /**边框距离 上右边下左 */
  background-color: white;
  overflow: hidden;
}
.recommend {
  border: 1px solid #b3c0d1;
  height: 350px;
  margin-bottom: 10px;
  border-radius: 5px;
  /* margin-top: 5px; */
}
.recommend_detail {
  text-align: left;
  font-weight: 900;
  color: #04312c;
  font-size: 20px;
  margin-left: 10px;
}
.el-divider {
  margin-left: 10px;
}
.scroll {
  text-align: left;
  margin: 10px;
  padding: 0px;
}
.space {
  margin-bottom: 10px;
}
.dot {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #005152;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  text-align: left;
}

.seamless-warp {
  height: 260px;
  overflow: hidden;
  /* background-color: yellow; */
  text-align: left;
}
li {
  list-style-type: none;
}
.title {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: clip; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行*/
  display: block;
}
.exceed {
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: clip; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}

.el-divider {
  background-image: linear-gradient(to right, #002412, #005152, #006a71);
  height: 2px;
  margin-top: 7px;
}
</style>



// WEBPACK FOOTER //
// src/view/notic.vue